import { startup } from 'components/app'
import LoginRoute from './login/index'

startup({
	login: LoginRoute
}, 'main-app')
